module.exports = __webpack_public_path__ + "static/media/status.32b2bcb4.svg";